import size from "../sizes";
import digitalPrinting from "./templates/digital-printing";
import maintenance from "./templates/maintenance";
import additionalOpportunity from "./templates/additional-opportunity";

export default [
  {
    id: `description`,
    title: `О товаре`,
  },
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `
        <p>Легкая нательная футболка с длинными рукавами из 100% чесаного хлопка отлично подойдет для носки в холодную погоду. Хорошая плотность материала (от 155гр/м<sup>2</sup> до 200гр/м<sup>2</sup>), прямые и ровные швы, а также качество покраски – гарантия того, что ваш лонгслив прослужит вам не один сезон.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати и уход`,
    content: {
      printingInfo: `${digitalPrinting}${additionalOpportunity}${maintenance}`
    }
  },
  {
    id: `size`,
    title: `Размерная сетка`,
    content: {
      table: size[`longsleeve`],
      sizeInfo: `longsleeve`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
